/*
 * Module for the PROP Deferral Application/Amendment step of the PROP Deferral and Distribution form
*/
rs.module("ui/content/communications/onlineforms/propdeferralapplicationamendment",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (selectHelper, eventBanner, visibility) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var deferralOptionRadio = stepContainer.js(jsSelectors.deferralOptionRadio, { multiple: true });
            var deferralOptionDescriptionDiv = stepContainer.js(jsSelectors.deferralOptionDescriptionDiv, { multiple: true });
            var partialDeferralAmount = stepContainer.js(jsSelectors.partialDeferralAmount);
            var propDisbursementDateSection = stepContainer.js(jsSelectors.propDisbursementDateSection, { required: false });
            var isAmendmentFlag = stepContainer.js(jsSelectors.isAmendmentFlag, { required: false });

            var selected = deferralOptionRadio.filter(":checked");
            var selectedIndex = deferralOptionRadio.index(selected);
            if (selectedIndex !== null && selectedIndex >= 0) {
                showSelectedPROPDeferralOptionDescription(selectedIndex);
            }

            // Handle the deferralOptionRadio click event
            deferralOptionRadio.on("click", function () {

                // Clear partial deferral amount and errors
                partialDeferralAmount.val('');
                partialDeferralAmount.clearErrors();

                var selectedIndex = deferralOptionRadio.index(this);
                showSelectedPROPDeferralOptionDescription(selectedIndex);
            });

            // Show (slide down) the description for the selected prop deferral option
            function showSelectedPROPDeferralOptionDescription(selectedIndex) {

                // Close all quickly
                deferralOptionDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                deferralOptionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);

                // Open the disbursement date section
                showSelectedPROPDisbursementDateSection(isAmendmentFlag);
            }

            // Show (slide down) the PROP Disbursement Date Section on amendments
            function showSelectedPROPDisbursementDateSection(isAmendment) {
                if (isAmendment) {
                    propDisbursementDateSection.stop(true, true).slideDown(150);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);